import byteSize from "byte-size";

export const getFileSize = (size: number) => {
  const values = byteSize(size, { precision: 2 });
  return `${values.value}${values.unit}`;
};
